module.exports = __webpack_public_path__ + "static/media/172.a96bf27c.svg";